export const SHARED_FILE_REQUIREMENT_EVENT = {
  UploadFile: "UploadFile",
  DownloadAsPayee: "DownloadAsPayee",
  DownloadAsPayer: "DownloadAsPayer"
} as const;
